module.exports = __webpack_public_path__ + "static/img/water.ec04bfb3.webp";